/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { type CommonProps } from '../_common/types';
import { FieldsetBase, type FieldsetProps } from '../fieldset/Fieldset';

type CheckboxGroupProps = FieldsetProps & {
  /** Shared native name for checkbox form values */
  name?: string;
};

/**
 * Groups atomic `Checkbox` components under an accessible legend.
 *
 * @remarks
 * Checked state remains on each `Checkbox`. Browsers cannot natively validate
 * an “at least one” checkbox requirement, so applications should set
 * `errorText` after validating a required group.
 */
const CheckboxGroup = ({
  name,
  isDisabled = false,
  isRequired = false,
  ...props
}: CommonProps<'fieldset', CheckboxGroupProps>) => (
  <FieldsetBase
    {...props}
    isDisabled={isDisabled}
    isRequired={isRequired}
    fieldGroup={{ controlType: 'checkbox', name }}
  />
);

CheckboxGroup.displayName = 'CheckboxGroup';

export { CheckboxGroup };
